// 토스트 컨테이너 — useUI.toasts를 화면 우상단에 누적 표시
import { useUI, type ToastType } from '../lib/uiStore';

const ICONS: Record<ToastType, string> = { success: '✓', error: '✗', warn: '⚠', info: 'ℹ' };

export function ToastHost() {
  const toasts = useUI((s) => s.toasts);
  return (
    <div className="toast-wrap" id="toastWrap">
      {toasts.map((t) => (
        <div key={t.id} className={`toast ${t.type}`} data-testid="toast">
          <span>{ICONS[t.type]}</span>
          <span>{t.msg}</span>
        </div>
      ))}
    </div>
  );
}
